<script lang="ts" module>
  type Stars = {
    stars: number;
    coords: [Coord, Coord];
  };

  const DEFAULT_STARS = {
    coords: [
      [0, 0],
      [0, 0],
    ] as Stars['coords'],
    stars: 0,
  };
  let stars = $state(DEFAULT_STARS);

  export const setStars = (s: Stars) => {
    stars = s;
  };

  export const clearStars = () => {
    stars.stars = 0;
  };
</script>

<script lang="ts">
  import { starIn, starOut } from '../animations.svelte';

  import Star from '../icons/Star.svelte';
  import type { Coord } from '~/types';
  import { getTileId } from '~/algorithms/letters';

  type Props = {
    pad: number;
    tileWidth: number;
    tileHeight: number;
    xScale: (n: number) => number;
    yScale: (n: number) => number;
  };

  const props: Props = $props();

  const vertical = $derived(stars.coords[1][1] - stars.coords[0][1] > 0);
  const width = $derived(stars.coords[1][0] - stars.coords[0][0] + 1);
  const height = $derived(stars.coords[1][1] - stars.coords[0][1] + 1);
</script>

<div
  class="stars"
  class:vertical
  style="
    width: {props.tileWidth * width}px;
    height: {props.tileHeight * height}px;
    transform: translate(
      {props.xScale(stars.coords[0][0]) -
    (props.tileWidth * (1 - props.pad)) / 2}px,
      {props.yScale(stars.coords[0][1]) -
    (props.tileWidth * (1 - props.pad)) / 2}px
    );
  "
>
  {#each Array.from({ length: stars.stars }) as star, i}
    <span
      in:starIn={{ duration: 250, delay: 150 }}
      out:starOut={{ duration: 500, delay: i * 100 }}
    >
      <Star size="36px" outlined />
    </span>
  {/each}
</div>

<style lang="scss">
  .stars {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    gap: 0.2em;
    &.vertical {
      flex-direction: column;
    }
    & span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
